/**
 * Feature flags (default ON; set the env var to "false" to disable).
 *
 * Per the two-sided direction (TODO/strategy/*), autopilot/sourcing/outreach are
 * the PAID RECRUITER SIDE — source the intent-scored pool, build pipeline, run
 * warm outreach. They are core product, enabled by default. The flag remains as an
 * ops kill-switch (set REACT_APP_ENABLE_* = "false" to hide). The matching backend
 * routes mirror this default.
 *
 * Guardrail (candidate side): auto-apply stays QUALITY-FIRST — apply into our own
 * employer side first; external submission is assistive (pre-filled, human-confirmed),
 * never spray. See strategy-and-wedge.md.
 */
export const FEATURES = {
  // Recruiter outreach engine (campaigns / queue / warm sequencing).
  autopilot: process.env.REACT_APP_ENABLE_AUTOPILOT !== 'false',
  // Sourcing surfaces: candidate pool tooling, job scraping.
  sourcing: process.env.REACT_APP_ENABLE_SOURCING !== 'false',
  // Multi-job mapping panel — its backend (/api/candidate) was Mongo-only and was
  // deleted in the Supabase migration. Default OFF until reimplemented on Supabase.
  multiJob: process.env.REACT_APP_ENABLE_MULTIJOB === 'true',
};

export default FEATURES;
